import React from 'react';
import PropTypes from 'prop-types';
import {createFragmentContainer} from 'react-relay';
import graphql from 'babel-plugin-relay/macro';
import withStyles from '@material-ui/core/styles/withStyles';

import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';

import Typography from '../../Typography'
import Input from '../../HylyField/HylyField';
import Icon from '../../Icon';
import ListItemIcon from '@material-ui/core/ListItemIcon';

const styles = theme => ({
  list_container: {
    display:'flex',
    flexDirection: 'column',
    flex:1,
    minHeight:0,

  },
  content: {
    display:"flex",
    flexDirection:'column',
    flex:1,
    overflowY:'auto',
    overflowX: 'hidden',
    width:'100%',
    padding: 0
  //  padding:`${theme.margins.md}px ${theme.margins.xs}px 0`
  },
  root_list_item: {
    cursor: "pointer",
    padding: theme.margins.xs,
    '&:hover': {
      background: theme.palette.lightGrey,
    },
    '&:first-child': {
      padding: `${theme.margins.md}px ${theme.margins.xs}px ${theme.margins.xs}px`,
    }
  },
  selected: {
    fontWeight: theme.fontWeight.bold,
  },
  selected_icon_container: {
    margin: `-2px auto auto ${theme.margins.xs}px`,
    color: theme.palette.hylyBlue
  },
  expand_icon_container: {
    margin:'0 0 0 auto',
    minWidth:10
  },
  temp_selection: {
    background: theme.palette.lightGrey,
  },
  typography: {
    whiteSpace:'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  }
});

const ListComponent = ({
    suggestions,
    classes,
    search_value,
    selected_value,
    onSelect,
    selected_icon_type,
    is_expanded,
    expand_icon_type,
    exapnd_icon_action,
    onmouseover_function,
    temp_selection
  }) => {

  function get_temp_selecte_class(id, temp_selection) {
    return id === temp_selection ? classes.temp_selection : '';
  }

  return (
    Boolean(suggestions && suggestions.length)
    ?
      <div className = {classes.list_container}>
        <List className = {classes.content}>
        {
          suggestions.map((item, index) => (
            <ListItem
               key = {`${item.id}-list-item-${index}`}
               onClick = { e => onSelect(e, item) }
               selected = {selected_value === item.id}
               onMouseEnter = {e => onmouseover_function(e, item)}
               classes = {{
                 root: classes.root_list_item + ' ' + get_temp_selecte_class(item.id, temp_selection),
                 selected:  classes.selected
               }}
               {...item}
           >
              <Typography
                  type = "body1"
                  className = {classes.typography}
                  font_weight = {400}
                  color = {
                    selected_value && selected_value === item.id
                    ? "hylyBlue"
                    :"darkBlack"
                  }
              >
               {item.name}
              </Typography>
              {
               Boolean(is_expanded)
               ? <ListItemIcon className = {classes.expand_icon_container}>
                   <Icon type = {expand_icon_type} size = "xs"/>
                 </ListItemIcon>
                : null
              }
          </ListItem>
        ))
      }
     </List>
    </div> : null
  )
}

ListComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  input_props: PropTypes.object,
  selected_value: PropTypes.string,
  search_value: PropTypes.string,
  selected_value: PropTypes.string,
  onSelect: PropTypes.func,
  selected_icon_type: PropTypes.string,
  is_expanded: PropTypes.bool,
  expand_icon_type: PropTypes.string,
  expand_icon_action: PropTypes.func,
  onmouseover_function: PropTypes.func
}

ListComponent.defaultProps = {
  expand_icon_type: "icon-right-arrow",
  is_expanded: true,
  selected_icon_type: "icon-check-single"
}

export default createFragmentContainer(
  React.memo(withStyles(styles)(ListComponent)),
  {
    suggestions: graphql`
      fragment ListComponent_suggestions on PicklistInterface @relay(plural:true)
      {
        id
        name
      }
    `
  });
